import React from 'react'

import './Image.scss'

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
}

const Image: React.FC<ImageProps> = ({ src, alt, className, ...props }) => {
  const classNames = ['internal-image', className].filter(Boolean).join(' ')
  return <img src={src} alt={alt} className={classNames} {...props} />
}

export default Image
